import { FormatMessageType } from '@hooks/useValidation';
import { LIST, REQUIRED_FIELD } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

import { LayerTypeEnum } from '@/types/config/settings.types';

export const mapLayerSchema = (formatMessage: FormatMessageType) => {
  return Yup.object({
    name: Yup.string().required(
      formatMessage({ id: REQUIRED_FIELD }, { field: formatMessage({ id: 'controls.toolMenu.maps.name' }) }),
    ),
    url: Yup.string().required(
      formatMessage({ id: REQUIRED_FIELD }, { field: formatMessage({ id: 'controls.toolMenu.maps.url' }) }),
    ),
    type: Yup.mixed<LayerTypeEnum>()
      .oneOf(Object.values(LayerTypeEnum), formatMessage({ id: LIST }))
      .required(
        formatMessage({ id: REQUIRED_FIELD }, { field: formatMessage({ id: 'controls.toolMenu.maps.type.type' }) }),
      ),
  });
};
